// @flow

import OptionManager from "./OptionManager";
import type {PhaseState} from "../components/CalculationPhaseInput";
import type {ProjectUiInput} from "../store/Calculation";
import Config from "./Config";

export default class DefaultValueManager {

    optionManager: OptionManager;
    
    defaultState: PhaseState;

    constructor(optionManager: OptionManager) {
        this.optionManager = optionManager;
        
        this.defaultState = {
                touched: {},
                error: {},

                // Basic info
                techniquesToCompare: -1,
                typeOfLandscapeBefore: this.optionManager.ids.TYPE_OF_LANDSCAPE_STREET,
                typeOfLandscapeAfter: this.optionManager.ids.TYPE_OF_LANDSCAPE_STREET,
                coatingBefore: this.optionManager.ids.COATING_ASPHALT,
                coatingAfter: this.optionManager.ids.COATING_ASPHALT,
                asphaltTypeAfter: this.optionManager.ids.ASPHALT_TYPE_TRADITIONAL,
                streetTypeBefore: this.optionManager.ids.STREET_TYPE_CITY,
                streetTypeAfter: this.optionManager.ids.STREET_TYPE_CITY,

                numExistingTubes: 1,
                existingTube1TubeType: -1,
                existingTube2TubeType: -1,
                existingTube3TubeType: -1,
                existingTube1TubeMaterial: -1,
                existingTube2TubeMaterial: -1,
                existingTube3TubeMaterial: -1,
                existingTube1TubeDiameter: -1,
                existingTube2TubeDiameter: -1,
                existingTube3TubeDiameter: -1,
                existingTube1TubeLength: -1,
                existingTube2TubeLength: -1,
                existingTube3TubeLength: -1,

                // Distances
                distanceReceiverFillingKm: 30,
                distanceReceiverCleanAsphaltKm: 30,
                distanceReceiverPollutedAsphaltKm: 30,
                distanceFillingKm: 30,
                distanceReceiverOldTubesKm: 30,

                // Traditional digging
                shaftDepthM: 3,
                slopeAngleN1: this.optionManager.ids.SLOPE_ANGLE_2,
                shaftCapacityM3PerHour: 10,
                shaftLengthM: -1,

                numTraditionalTubes: 1,
                traditionalTube1TubeType: -1,
                traditionalTube2TubeType: -1,
                traditionalTube3TubeType: -1,
                traditionalTube1TubeMaterial: -1,
                traditionalTube2TubeMaterial: -1,
                traditionalTube3TubeMaterial: -1,
                traditionalTube1TubeDiameter: -1,
                traditionalTube2TubeDiameter: -1,
                traditionalTube3TubeDiameter: -1,
                traditionalTube1TubeLength: -1,
                traditionalTube2TubeLength: -1,
                traditionalTube3TubeLength: -1,

                // Insertion flexible lining
                iflPointShafts: 0,
                iflMetersLongerBottomLengthThanWidth: 0,
                iflShaftDepthM: 3,
                iflSlopeAngleN1: this.optionManager.ids.SLOPE_ANGLE_2,
                iflShaftCapacityM3PerHour: 10,
                iflShaftLengthM: -1,

                numIflTubes: 1,
                iflTube1TubeType: -1,
                iflTube2TubeType: -1,
                iflTube1TubeDiameter: -1,
                iflTube2TubeDiameter: -1,
                iflTube1TubeLength: -1,
                iflTube2TubeLength: -1,

                // Tube cracking
                tcPointShafts: 2,
                tcMetersLongerBottomLengthThanWidth: 0,
                tcShaftDepthM: 3,
                tcSlopeAngleN1: this.optionManager.ids.SLOPE_ANGLE_2,
                tcShaftCapacityM3PerHour: 10,
                tcShaftLengthM: -1,

                numTcTubes: 1,
                tcTube1TubeType: -1,
                tcTube2TubeType: -1,
                tcTube3TubeType: -1,
                tcTube1TubeMaterial: -1,
                tcTube2TubeMaterial: -1,
                tcTube3TubeMaterial: -1,
                tcTube1TubeDiameter: -1,
                tcTube2TubeDiameter: -1,
                tcTube3TubeDiameter: -1,
                tcTube1TubeLength: -1,
                tcTube2TubeLength: -1,
                tcTube3TubeLength: -1,

                // Directed drilling
                ddPointShafts: 2,
                ddMetersLongerBottomLengthThanWidth: 0,
                ddShaftDepthM: 3,
                ddSlopeAngleN1: this.optionManager.ids.SLOPE_ANGLE_2,
                ddShaftCapacityM3PerHour: 10,
                ddShaftLengthM: -1,

                numDdTubes: 1,
                ddTube1TubeType: -1,
                ddTube2TubeType: -1,
                ddTube3TubeType: -1,
                ddTube1TubeMaterial: -1,
                ddTube2TubeMaterial: -1,
                ddTube3TubeMaterial: -1,
                ddTube1TubeDiameter: -1,
                ddTube2TubeDiameter: -1,
                ddTube3TubeDiameter: -1,
                ddTube1TubeLength: -1,
                ddTube2TubeLength: -1,
                ddTube3TubeLength: -1,

                // Sliplining
                slPointShafts: 2,
                slMetersLongerBottomLengthThanWidth: 0,
                slShaftDepthM: 3,
                slSlopeAngleN1: this.optionManager.ids.SLOPE_ANGLE_2,
                slShaftCapacityM3PerHour: 10,
                slShaftLengthM: -1,
    
                numSlTubes: 1,
                slTube1TubeType: -1,
                slTube1TubeMaterial: -1,
                slTube1TubeDiameter: -1,
                slTube1TubeLength: -1,

                // PU lining
                pulPointShafts: 0,
                pulMetersLongerBottomLengthThanWidth: 0,
                pulShaftDepthM: 3,
                pulSlopeAngleN1: this.optionManager.ids.SLOPE_ANGLE_2,
                pulShaftCapacityM3PerHour: 10,
                pulShaftLengthM: -1,
    
                numPulTubes: 1,
                pulTube1TubeType: -1,
                pulTube1TubeDiameter: -1,
                pulTube1TubeLength: -1,

        };

    }
    
    getDefaultState(): PhaseState {
        return {...this.defaultState};
    }; 
    
    getDefaultProjectState(): ProjectUiInput {
        return {
            version: Config.version,
            
            error: {},
            touched: {},
            personName: '',
            projectName: '',
            organisationName: '',

            phaseStates: [this.defaultState]
        }
    }; 
    
    getDefaultValue(name: string): number {
        return this.defaultState[name];
    }
    
    getDefaultCoating(typeOfLandscape: number): number {
        switch(typeOfLandscape) {
            case this.optionManager.ids.TYPE_OF_LANDSCAPE_STREET:
                return this.optionManager.ids.COATING_ASPHALT;
            default:
                return this.optionManager.ids.COATING_GREEN;
        }        
    }

    getDefaultStreetType(coating: number): number {
        switch(coating) {
            case this.optionManager.ids.COATING_ASPHALT:
                return this.optionManager.ids.STREET_TYPE_CITY;
            default:
                return -1;
        }        
    }

    getDefaultAsphaltType(coating: number): number {
        switch(coating) {
            case this.optionManager.ids.COATING_ASPHALT:
                return this.optionManager.ids.ASPHALT_TYPE_TRADITIONAL;
            default:
                return -1;
        }        
    }

}


// WEBPACK FOOTER //
// ./src/common/DefaultValueManager.js